<template>
  <div class="track-big-mg" style="border-bottom:1px #fff solid;">
    <div class="track-shadow2" style="margin-top: 25px ">
      <el-form :model="form" style="position: relative;">
        <el-row style="width:200px; ">
          <el-form-item style="margin-bottom: 0px;">
            <el-select class="track-input1" v-model="form.startPort" placeholder="请选择起运港">
              <el-option
                v-for="(item,index) in portArry"
                :key="index"
                :label="item.port"
                :value="item.portEN"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-row>

        <!-- 英文船名查询 -->
        <el-row style="position: absolute;top: 0px;left: 191px; ">
          <el-col :span="3" style="width: 500px;padding-left: 8px;padding-right: 8px;">
            <el-form-item style="margin-bottom: 0px;" class="cgs">
              <el-input
                class="track-input2 track-border"
                clearable
                placeholder="请输入英文船名"
                v-model="form.voyage"
              ></el-input>
            </el-form-item>
            <div
              :class="hidden3==0 ? 'ant-tooltip-hidden':''"
              class="ant-tooltip product-service-tooltip"
              style="left: 18px;top: 48px;transform-origin: 0px -4px;"
            >
              <div class="ant-tooltip-content">
                <div class="ant-tooltip-arrow"></div>
                <div class="ant-tooltip-inner" v-if="this.Check === 1">请输入英文船名</div>
                <div class="ant-tooltip-inner" v-if="this.Check === 2">请输入正确订单号</div>
              </div>
            </div>
          </el-col>
          <el-col :span="10" class="track-input2 track-border" style="width: 320px;">
            <el-form-item style="margin-bottom: 0px;">
              <el-input clearable placeholder="请输入航次" v-model="form.orderNumber"></el-input>
            </el-form-item>
            <div
              :class="hidden1==0 ? 'ant-tooltip-hidden':''"
              class="ant-tooltip product-service-tooltip"
              style="left: 510px;top: 48px;transform-origin: 0px -4px;"
            >
              <div class="ant-tooltip-content">
                <div class="ant-tooltip-arrow"></div>
                <div class="ant-tooltip-inner">请输入航次</div>
              </div>
            </div>
          </el-col>
          <el-col :span="4" style="margin-left: 20px;">
            <el-form-item style="margin-bottom: 0px;">
              <el-button class="track-button" icon="el-icon-search" @click="Inquire(form)">船舶计划查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="history">
          <el-row v-if="this.historys == 1">
            <el-col :span="2" style="margin-left: 5px; width:61px;">
              <div class="grid-content bg-purple">历史查询:</div>
            </el-col>
            <el-col :span="22" style="width:1134px;">
              <li :span="3" v-for="(item,index) in HistoryForm" style="width:160.5px;float: left;">
                <el-tooltip placement="bottom" effect="dark">
                  <div
                    class="history_item"
                    @click="historyClick(item)"
                  >{{item.vesselNameEn}}/{{item.exportVoyage}}</div>
                  <div
                    slot="content"
                    style="height: 10px;line-height: 10px;"
                  >{{item.vesselNameEn}}/{{item.exportVoyage}}</div>
                </el-tooltip>
              </li>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>

    <div class="track-shadow" style="padding: 30px;" v-loading="loading">
      <div v-show="status">
        <div class="portPlan">
          <span class="portPlan-prior">起运港船舶计划</span>
          <span v-if="this.lastModifyTime" class="portPlan-After">计划更新时间：{{this.lastModifyTime}}</span>
        </div>
        <div style="padding-bottom:20px;" v-if="this.planForm.length > 0">
          <el-table
            :data="planForm"
            class="ot_text ShippingPlan_table"
            style="border: 1px #EAEAEA solid; margin-top: 20px; font-size: 12px; "
          >
            <el-table-column prop="vesselPlanStatus" label="状态"></el-table-column>
            <el-table-column prop="polTerminalName" label="靠泊码头" width="120"></el-table-column>
            <el-table-column label="航次（进口/出口）" width="150">
              <div>
                <div class="sp_access">{{planForm[0].voyImport}}</div>
                <span
                  style=" margin: 0 10px;"
                  v-if="planForm[0].voyImport || planForm[0].voyExport"
                >/</span>
                <div class="sp_access">{{planForm[0].voyExport}}</div>
              </div>
            </el-table-column>
            <el-table-column prop="cyOpenTime" label="开港时间" width="110"></el-table-column>
            <el-table-column prop="cyCloseTime" label="截港时间" width="110"></el-table-column>
            <el-table-column prop="eta" label="计划靠泊时间" width="110"></el-table-column>
            <el-table-column prop="etd" label="计划离泊时间" width="110"></el-table-column>
            <el-table-column prop="ata" label="实际靠泊时间" width="110"></el-table-column>
            <el-table-column prop="atd" label="实际离泊时间" width="110"></el-table-column>
            <el-table-column prop="lastPort" label="上一港" width="100"></el-table-column>
          </el-table>
        </div>
        <div
          v-if="this.planForm.length == 0"
          style="margin-top: 20px;margin-bottom: 20px;border: 1px solid #EBEEF5;padding-bottom: 40px;color: #959595;padding-top: 40px;font-family: 'SourceHanSans-Medium';"
        >暂未查询到船舶计划相关信息，请稍后重试</div>
        <div class="portPlan">
          <span class="portPlan-prior">船舶信息</span>
        </div>
        <div style="padding-bottom:20px;" v-if="this.messageForm.length > 0">
          <el-table
            :data="messageForm"
            class="ot_text"
            style="border: 1px #EAEAEA solid; margin-top: 20px; font-size: 12px; "
          >
            <el-table-column prop="cost" label="英文船名"></el-table-column>
            <el-table-column prop="unit" label="中文船名" width="120"></el-table-column>
            <el-table-column prop="quantity" label="MMSI" width="120"></el-table-column>
            <el-table-column prop="price" label="IMO" width="120"></el-table-column>
            <el-table-column prop="Currency" label="呼号" width="120"></el-table-column>
            <el-table-column prop="point" label="船国籍" width="120"></el-table-column>
            <el-table-column prop="untaxed" label="建造时间" width="120"></el-table-column>
            <el-table-column prop="summation" label="船舶尺寸" width="120"></el-table-column>
            <el-table-column prop="summation" label="船重" width="120"></el-table-column>
          </el-table>
        </div>
        <div
          v-if="this.messageForm.length == 0"
          style="margin-top: 20px;margin-bottom: 20px;border: 1px solid #EBEEF5;padding-bottom: 40px;color: #959595;padding-top: 40px;font-family: 'SourceHanSans-Medium';"
        >暂未查询到船舶相关信息，请稍后重试</div>
      </div>
      <div v-show="!status">
        <div class="track-no-padding">
          <div class="track-no-data"></div>
          <div class="track-no-font">暂未查询到相关船舶计划，请稍后重试</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
export default {
  data() {
    return {
      historys: "0",
      hidden1: "0", //船公司校验
      hidden3: "0", //船期校验
      loading: false,
      form: {
        startPort: "", //起运港
        orderNumber: "", //船名
        voyage: "" //航次
      },
      Check: 0, //订单号校验参数
      portArry: [
        //起运港数组
        { port: "上海港", portEN: "CNSHA" },
        { port: "宁波港", portEN: "CNNGB" },
        { port: "深圳港", portEN: "CNSZX" },
        { port: "广州港", portEN: "CNCAN" },
        { port: "青岛港", portEN: "CNTAO" },
        { port: "天津港", portEN: "CNTNJ" },
        { port: "大连港", portEN: "CNDLC" }
      ],
      lading: [],
      // 船舶计划
      planForm: [],
      // 船信息
      lastModifyTime: "",
      //船舶计划更新时间
      messageForm: [],
      HistoryForm: [],
      status: true //标记是否有数据
    };
  },
  mounted: function() {
    this.history();
    this.form.startPort = this.portArry[0].portEN; //默认选中青岛港
    // this.trackQuery();
    if (this.$route.params.vslNameEn) {
      this.form.voyage = this.$route.params.vslNameEn;
      this.form.orderNumber = this.$route.params.voyExport;
      this.form.startPort = this.$route.params.polCode;
      this.trackQuery();
    }
  },
  methods: {
    //跟踪查询校验
    Inquire(value) {
      var st = this.form.orderNumber;
      var ed = this.form.voyage;
      let that = this;
      if (!st && !ed) {
        that.hidden1 = 1;
        that.Check = 1;
        that.hidden3 = 1;
        setTimeout(function() {
          that.hidden1 = "0";
          that.hidden3 = "0";
        }, 3000);
        return false;
      } else if (st && !ed) {
        that.hidden1 = 0;
        that.Check = 1;
        that.hidden3 = 1;
        setTimeout(function() {
          that.hidden2 = "0";
        }, 3000);
        return false;
      } else if (!st && ed) {
        that.hidden1 = 1;
        if (/[\u4E00-\u9FA5]/g.test(ed)) {
          that.hidden3 = 1;
          that.Check = 2;
        } else {
          that.hidden3 = 0;
        }
        setTimeout(function() {
          that.hidden1 = "0";
        }, 3000);
        return false;
      } else {
        this.loading = true;
        this.trackQuery(value);
      }
    },
    // 销售线索
    async clue(e) {
      let that = this;
      var getfo = JSON.parse(localStorage.getItem("userInfo"));
      var ww = e.etd.replace(/\//g, "-");
      let data = {};
      data.salesLeadsType = "VP";
      data.opsCustId = getfo.opsCustId;
      data.opsUserId = getfo.opsUserId;
      data.userDomainCode = "SSLCP";
      data.salesLeadsVesselPlan = {};
      data.salesLeadsVesselPlan.vesselNameEn = that.form.voyage;
      // data.salesLeadsVesselPlan.vesselNameCn = that.startPortCode;
      data.salesLeadsVesselPlan.exportVoyage = that.form.orderNumber;
      data.salesLeadsVesselPlan.polCode = that.form.startPort;
      data.salesLeadsVesselPlan.polEtd = ww;
      await that.apiService
        .post("/sinoslog-ops-service/salesLeads/salesLeadsRecord", data)
        .then(res => {});
    },
    //订单跟踪查询
    async trackQuery(value) {
      var self = this;
      let params = {};
      params.vslNameEn = this.form.voyage;
      params.voyExport = this.form.orderNumber;
      params.polCode = this.form.startPort;
      params.voyImport = "";
      let response = await this.apiService
        .get("/sinoslog-ops-service/sailingDate/vesselPlanOfPol", { params })
        .then(res => {
          this.loading = false;
          this.planForm = [];
          this.clue(res.data.data);
          if (res.data.data) {
            var ss = res.data.data;

            if (res.data.data.lastModifyTime) {
              this.lastModifyTime = res.data.data.lastModifyTime;
            }
            this.planForm.push(ss);
          }
        });
    },
    /**
     * 格式化日期,特殊定制化的格式化
     **/
    dataFormat(date, format) {
      // 兼容IE
      var time;
      if (!date) return "";
      if (typeof date === "string") {
        time = new Date(
          date
            .replace(/-/g, "/")
            .replace(/T|Z/g, " ")
            .trim()
        );
      } else if (typeof date === "object") {
        time = new Date(date);
      }
      var o = {
        "M+": time.getMonth() + 1, //月份
        "d+": time.getDate(), //日
        "h+": time.getHours(), //小时
        "m+": time.getMinutes(), //分
        "s+": time.getSeconds(), //秒
        "q+": Math.floor((time.getMonth() + 3) / 3), //季度
        S: time.getMilliseconds() //毫秒
      };
      if (/(y+)/.test(format))
        format = format.replace(
          RegExp.$1,
          (time.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      for (var k in o)
        if (new RegExp("(" + k + ")").test(format))
          format = format.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
      return format;
    },

    refresh() {
      this.status = false;
    },
    // 获取历史记录
    async history() {
      let len = JSON.parse(localStorage.getItem("userInfo"));
      var that = this;
      let params = {};
      params.opsUserId = len.opsUserId;
      params.salesLeadsType = "VP";
      let response = await this.apiService
        .get("/sinoslog-ops-service/salesLeads/userSearchHistory", {
          params
        })
        .then(res => {
          if (res.data.data) {
            if (res.data.data.length) {
              this.historys = 1;
              this.HistoryForm = res.data.data;
            } else {
              this.historys = 0;
              return false;
            }
          } else {
            this.historys = 0;
            return false;
          }
        });
    },
    //历史记录点击
    historyClick(e) {
      this.form.orderNumber = e.exportVoyage;
      this.form.voyage = e.vesselNameEn;
      this.trackQuery();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.track-input1 {
  width: 100%;
}

.track-input1 input {
  line-height: 1.4;
  border-color: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 45px;
  width: 100%;
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}
.track-input2 input {
  margin-left: 10px;
  line-height: 1.4;
  border-color: #fff;
  border-radius: 0;
  height: 45px;
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}

.track-shadow {
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
  border: 1px solid #eaeaea;
}

.track-no-data {
  background: url("../assets/img/no-data.png") no-repeat center;
  width: 100%;
  height: 116px;
}
.track-no-font {
  font-family: "SourceHanSans-Regular";
  color: #999999;
  font-size: 16px;
}
.track-no-padding {
  padding: 80px 100px 140px 100px;
}
.track-big-mg {
  margin: 0 8% 30px 11%;
  width: 1200px;
  margin: 0 auto;
}
.track-button:hover {
  background: #66b1ff !important;
  border-color: #66b1ff !important;
  color: #fff !important;
}

.track-button {
  float: right !important;
  width: 180px !important;
  border-color: #fff;
  border-radius: 0;
  height: 45px;
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  background-color: #fff;
}

/* 起运港船舶计划 */
.portPlan {
  text-align: left;
}
.portPlan-prior {
  font-size: 14px;
  font-weight: 700;
  font-family: "SourceHanSans-Regular";
}
.portPlan-After {
  padding-left: 10px;
  font-size: 14px;
  font-weight: 700;
  font-family: "SourceHanSans-Regular";
}
.track-input3 {
  margin-left: 10px;
}
.track-input3 input {
  line-height: 1.4;
  border-color: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  height: 45px;
  width: 200px;
  -webkit-box-shadow: 0px 1px 3px #888888;
  -moz-box-shadow: 0px 1px 3px #888888;
  -o-box-shadow: 0px 1px 3px #888888;
  box-shadow: 0px 1px 3px #888888;
  border-radius: 3px;
  background-color: #fff;
}
/* .el-table .cell {
  width: 100px;
} */
.ShippingPlan_table
  > .is-scrolling-none
  > .el-table__body
  > tbody
  > .el-table__row
  > td
  > .cell {
  width: 90px;
}
.ShippingPlan_table
  > .is-scrolling-none
  > .el-table__body
  > tbody
  > .el-table__row
  > td:nth-child(3)
  > .cell {
  width: 130px;
}
.ShippingPlan_table
  > .is-scrolling-none
  > .el-table__body
  > tbody
  > .el-table__row
  > td:nth-child(2)
  > .cell {
  width: 130px;
}
.ShippingPlan_table
  > .is-scrolling-none
  > .el-table__body
  > tbody
  > .el-table__row
  > td:nth-child(10)
  > .cell {
  width: 130px;
}
.ot_text th > .cell {
  font-family: "SourceHanSans-Regular";
  font-size: 12px;
  color: #2c3e50;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/ShippingPlan.vue